import { TextFieldProps } from "@mui/material/TextField";

const MuiTextField: TextFieldProps = {
  variant: "outlined",
  margin: "normal",
};

export default MuiTextField;
